<script lang="ts">
	import IKS from "./IKS.svelte";
	import { CircleWithWarning } from "@hitit/new_ui/src";
	import { t } from "@hitit/hub/src/stores";
	//
	import type { Menu, Category } from "../../../functions/place/types";
	import MenuEditor from "./MenuEditor.svelte";
	import MenuViewer from "./MenuViewer.svelte";

	export let editmode = false;
	export let categories: Category[] = [];

	const filterVisibleCategoryCallback = (category: Category) => {
		const visibleMenus = category.menus.filter((v) => v.show);
		return visibleMenus.length !== 0;
	};

	$: visibleCategory = categories.filter(filterVisibleCategoryCallback);

</script>

<IKS name={'메뉴'}>
	<img src="/img/icons/placeMenu.png" alt="place menu icon" slot="image" />
	<div
		class="container"
		class:editmode
		class:noContent={visibleCategory.length === 0}>
		{#if editmode}
			<MenuEditor categories={categories} on:CHANGE_ALL_MENUS on:CHANGE_MENU />
		{:else if visibleCategory.length > 0}
			<MenuViewer categories={categories} />
		{:else}
			<div class="no-content">
				<div class="no-menu">
					<div class="circle">
						<CircleWithWarning fill={'#bcbfc3'} />
					</div>
					<p class="desc">{$t('hub.place.No_visible_menus')}</p>
				</div>
				<p class="sub-desc">{$t('hub.place.Auto_regist_menu_by_app')}</p>
			</div>
		{/if}
	</div>
</IKS>

<style lang="scss">
	@import "../../../variables.scss";
	img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.container {
		padding-left: 28px;

		&.editmode {
			padding-left: 0px;
		}

		&:not(.editmode).noContent {
			padding-left: 28px;
		}

		.no-content {
			display: flex;
			flex-direction: column;
			gap: 6px;

			.sub-desc {
				font-size: 0.875rem;
				color: #6d6f76;
			}
			.no-menu {
				display: flex;
				align-items: center;
				gap: 10px;
				color: #46474b;

				.circle {
					width: 20px;
					height: 20px;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			padding-left: 38px;
			max-width: 555px;

			&.editmode {
				padding-left: 38px;
			}

			&:not(.editmode).noContent {
				padding-left: 38px;
			}
			.no-content {
				gap: 10px;
				.sub-desc {
					font-size: 1rem;
				}
				.no-menu {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
